export default __webpack_public_path__ + "static/media/orders_icon.187b7886.svg";